import { HttpResponse } from 'msw';
import { setCookie } from 'src/modules/web-ui/utils/cookie-utils';

import { TEST_CREDENTIALS } from '../constants';

type LegacyBody = {
  service?: string;
  command?: string;
  parameters?: unknown;
};

export function handleUserLegacy(
  body: LegacyBody,
  userFromCookie: string | null,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  switch (command) {
    case 'login': {
      const parameters = body.parameters as { user: string; password: string };
      if (parameters?.user && parameters?.password) {
        setCookie('user', parameters.user);
        return HttpResponse.json(
          {
            success: true,
            msg: 'Login successful',
            message: 'Login successful',
          },
          {
            status: 200,
            headers: {
              'Set-Cookie': `user=${parameters.user}; Path=/; SameSite=Lax`,
            },
          },
        );
      }
      return HttpResponse.json(
        {
          success: false,
          msg: 'Invalid credentials',
          message: 'Invalid credentials',
        },
        { status: 401 },
      );
    }
    case 'logout':
      return HttpResponse.json(
        { success: true, msg: 'Logout successful' },
        {
          status: 200,
          headers: {
            'Set-Cookie':
              'user=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; SameSite=Lax',
          },
        },
      );
    case 'get level':
      return HttpResponse.json(
        {
          level:
            Number(
              TEST_CREDENTIALS.find((cred) => cred.user === userFromCookie)
                ?.userLevel ?? '0',
            ) || 0,
        },
        { status: 200 },
      );
    case 'get users':
      return HttpResponse.json(
        {
          users: [{ user: 'admin' }, { user: 'operator' }, { user: 'viewer' }],
        },
        { status: 200 },
      );
    case 'add user':
    case 'remove user':
    case 'change user password':
      return HttpResponse.json({ ok: true }, { status: 200 });
    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for user:${command}`,
        },
        { status: 400 },
      );
  }
}
